import { compose } from "./compose";
import { AppContainer } from "./app/app.container";
// import { StoryEditContainer } from "./story/story-edit.container";

const GeneralContainer = (props: any): JSX.Element => {
  return compose([AppContainer], props.children);
};

export { GeneralContainer };
